<template>
    <!--d-none d-lg-block-->
    <v-data-table class="my-5 rounded bordered" :headers="tabel.paised" :items="elemendid"
        :items-per-page="tabel.lehePikkus" :loading="tabel.laeb" fixed-header item-key="id">
        <template v-slot:bottom> </template>
        <template v-slot:[`item.algusKp`]="{ value }">
            {{ formateeriKuupaev(value) }}
        </template>
        <template v-slot:[`item.loppKp`]="{ value }">
            <template v-if="value">{{ formateeriKuupaev(value) }}</template>
        </template>
        <template v-slot:[`item.tunnid`]="{ item }">
            {{ item.tunnid }}h {{ item.minutid }}min
        </template>
    </v-data-table>
    <v-data-iterator class="d-none d-lg-none" :items="elemendid" item-value="lahendiNr">
        <template v-slot:default="{ items }">
            <v-row>
                <v-col class="w-100" cols="auto" >                   
                        <v-expansion-panels variant="accordion" multiple>
                            <v-expansion-panel v-for="(item, index) in items" :key="index">
                                <v-expansion-panel-title>
                                    Sooritamise koht.: {{ item.raw.sooritamiseKoht }}
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-list :lines="false" density="compact">
                                        <v-list-item :title="formateeriKuupaev(item.raw.algusKp)">
                                            <template v-slot:title="{ title }">
                                                <b>Algus kp:</b> {{ title }}
                                            </template>
                                        </v-list-item>
                                        <v-list-item v-if="item.raw.loppKp" :title="formateeriKuupaev(item.raw.loppKp)">
                                            <template v-slot:title="{ title }">
                                                <b>Lõpp kp:</b> {{ title }}
                                            </template>
                                        </v-list-item>
                                        <v-list-item :title="item.raw.tunnid">
                                            <template v-slot:title="{ title }">
                                                <b>Sooritatud tunnid:</b> {{ title }}
                                            </template></v-list-item>                                       
                                    </v-list>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                 
                </v-col>
            </v-row>

            <v-row class="d-none">
                <v-col class="w-100" cols="auto" v-for="(item, index) in items" :key="index">
                    <v-card class="mx-auto">
                        <template v-slot:title>
                            Sooritamise koht.: {{ item.raw.sooritamiseKoht }}
                        </template>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-title>
                                    Sooritamise koht.: {{ item.raw.sooritamiseKoht }}
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-list :lines="false" density="compact">
                                        <v-list-item :title="formateeriKuupaev(item.raw.algusKp)">
                                            <template v-slot:title="{ title }">
                                                <b>Algus kp:</b> {{ title }}
                                            </template>
                                        </v-list-item>
                                        <v-list-item :title="formateeriKuupaev(item.raw.loppKp)">
                                            <template v-slot:title="{ title }">
                                                <b>Lõpp kp:</b> {{ title }}
                                            </template>
                                        </v-list-item>
                                        <v-list-item :title="item.raw.tunnid">
                                            <template v-slot:title="{ title }">
                                                <b>Sooritatud tunnid:</b> {{ title }}
                                            </template></v-list-item>                                       
                                    </v-list>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-data-iterator>
</template>
<script lang="ts">
import { PropType, defineComponent } from 'vue';
import mixin from '@/core/mixins';
import { TundideAsendamineListItem } from '@/models/UldkasulikToo';

export default defineComponent({
    name: 'UKTTundideAsendamiseTabel',
    mixins: [mixin],
    data() {
        return {
            tabel: {
                paised: [
                    {
                        title: 'Sooritamise koht',
                        sortable: false,
                        key: 'sooritamiseKoht',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Algus kp',
                        sortable: false,
                        key: 'algusKp',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Lõpp kp',
                        sortable: false,
                        key: 'loppKp',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Sooritatud tunnid',
                        sortable: false,
                        key: 'tunnid',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                ],
                laeb: false,
                lehePikkus: -1
            },
        }
    },
    props: {
        elemendid: Array as PropType<Array<TundideAsendamineListItem>>,
    },
});
</script>

<style scoped>
.bordered {
    border: 1px solid var(--varv-lisa-3);
}
</style>